import React, { useState, useEffect } from 'react';
import SimulationCard from './SimulationCard';
import './custom-style.css';

const SimulationCardList = () => {
  const [cards, setCards] = useState([]);
  const [IsLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const fetchData = async () => {
    if (isFetching) return;
    setIsFetching(true);

    try {
      const currentTime = new Date();
      const to = currentTime.getTime() + 4;
      currentTime.setHours(currentTime.getHours() - 4);
      const from = currentTime.getTime();
      // console.log(`Fetching data from ${from} to ${to}`);

      const profileCode = localStorage.getItem('profile_code');  // if the profile doesn't have a velue the LHCCB will be the defaukt value 

      const token = localStorage.getItem('authToken');
      const response = await fetch(
        `${window.env.NM_MEASURE_GW_API_BASE_URL}/api/1/flow/tmis/${profileCode}?from=${from}&to=${to}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      console.log(profileCode + ' lolo');
      if (!response.ok) {

        throw new Error('Failed to fetch cards');
      }

      const data = await response.json();
      setCards(data);
      console.log(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsFetching(false);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  if (IsLoading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="card-container">
      {cards.length > 0 ? (
        cards.map((card) => (
          <SimulationCard
            key={card.sessionId}
            sessionId={card.sessionId}
            sourceEvent={card.sourceEvent}
            status={card.status}
            measures={card.measures}
            tfv={card.tfv}
            createdAt={card.createdAt}
            updatedAt={card.updatedAt}
            state={card.state || 'Undefined'}
            statusLabel={card.statusLabel || 'Unknown'}
            simulationState={card.simulationState || 'Unknown'}
          />
        ))
      ) : (
        <p>No measures available.</p>
      )}
    </div>
  );
};

export default SimulationCardList;
